import {
  SeatType,
  SeatWithRelations,
} from "../../bookmydesk-api-sdk-typescript-axios";
import { kSeatTags } from "./seat-tags";
import { kUserGroups } from "./user-groups";

export const kSeats: SeatWithRelations[] = [
  {
    id: "00000011-0000-4000-a000-000000000010",
    name: "Seat 1",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(0, 2),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-000000000011",
    name: "Seat 2",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(1, 3),
    userGroups: kUserGroups.slice(0, 2),
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-000000000012",
    name: "Lunch Spot 1",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "lunch" as SeatType,
    seatTags: kSeatTags.slice(2, 4),
    userGroups: kUserGroups.slice(2, 3),
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: true,
    },
  },
  {
    id: "00000011-0000-4000-a000-000000000013",
    name: "Meeting Chair 1",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "meeting" as SeatType,
    seatTags: kSeatTags.slice(3, 5),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: true,
    },
  },
  {
    id: "00000011-0000-4000-a000-400000000003",
    name: "Seat 3",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(0, 3),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-400000000004",
    name: "Seat 4",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(1, 4),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-400000000005",
    name: "Seat 5",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(2, 5),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-400000000006",
    name: "Seat 6",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(0, 4),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-400000000007",
    name: "Seat 7",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(1, 5),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-400000000008",
    name: "Seat 8",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(0, 2),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-400000000009",
    name: "Seat 9",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(1, 3),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-400000000010",
    name: "Seat 10",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(2, 4),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-400000000011",
    name: "Seat 11",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(3, 5),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: true,
    },
  },
  {
    id: "00000011-0000-4000-a000-400000000012",
    name: "Seat 12",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(0, 3),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: true,
    },
  },
  {
    id: "00000011-0000-4000-a000-400000000013",
    name: "Seat 13",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(1, 4),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: true,
    },
  },
  {
    id: "00000011-0000-4000-a000-400000000014",
    name: "Seat 14",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(2, 5),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: true,
    },
  },
  {
    id: "00000011-0000-4000-a000-400000000015",
    name: "Seat 15",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(0, 4),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: true,
    },
  },
  {
    id: "00000011-0000-4000-a000-400000000016",
    name: "Seat 16",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(1, 5),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: true,
    },
  },
  {
    id: "00000011-0000-4000-a000-400000000017",
    name: "Seat 17",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(0, 2),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: true,
    },
  },
  {
    id: "00000011-0000-4000-a000-400000000018",
    name: "Seat 18",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(0, 2),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: true,
    },
  },
  {
    id: "00000011-0000-4000-a000-400000000019",
    name: "Seat 19",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(0, 4),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: true,
    },
  },
  {
    id: "00000011-0000-4000-a000-400000000020",
    name: "Seat 20",
    mapId: "00000011-0000-4000-a000-000000000005",
    coordX: 1,
    coordY: 2,
    zoneCoordinates: null,
    isZone: false,
    reservationCapacity: 1,
    isActive: true,
    notFutureReservable: false,
    seatType: "desk" as SeatType,
    seatTags: kSeatTags.slice(0, 1),
    userGroups: [],
    barcodes: [],
    seatExternals: [],
    _operations: {
      canDeactivate: true,
      canDelete: true,
    },
  },
];
